import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import { LOCATIONS, storageKey } from 'constants/index';

import AppLoading from 'components/App/Loading';
import { PERMISSION } from 'constants/accountSettingPermission';
import { showToastError } from 'utils';

const AuthMiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  path,
  isLoadingGetMyPermission,
  myPermission,
  loginTypes,
  ...rest
}) => {
  const accessToken = localStorage.getItem(storageKey.AUTHENTICATE_TOKEN);
  const currentLoginType = localStorage.getItem(storageKey.LOGIN_TYPE);

  const renderLayout = (props) => {
    if (isLoadingGetMyPermission) {
      return <AppLoading loading loaderOnPage />;
    }

    return (
      <Layout>
        <Component {...props} />
      </Layout>
    );
  };
  const findPermissionItem = (items, currentPath) => items.reduce((found, item) => {
    if (found) return found;

    if (item.path === currentPath
      || (Array.isArray(item.path) && item.path.includes(currentPath))) {
      return { item, matchedPath: currentPath };
    }

    if (item.children) {
      const childMatch = item.children.find((child) => child.path === currentPath
      || (Array.isArray(child.path) && child.path.includes(currentPath)));
      if (childMatch) {
        return { item, childItem: childMatch, matchedPath: currentPath };
      }
      return findPermissionItem(item.children, currentPath);
    }

    return null;
  }, null);

  const checkHasPermission = () => {
    const permissionMatch = findPermissionItem(PERMISSION, path);

    if (myPermission.accountSetting && permissionMatch) {
      const { item, childItem, matchedPath } = permissionMatch;

      const checkPermissionValue = (permItem, childPermItem) => {
        if (childPermItem) {
          return myPermission.accountSetting[permItem.value][childPermItem.value];
        }

        if (typeof myPermission.accountSetting[permItem.value] === 'boolean') {
          return myPermission.accountSetting[permItem.value];
        }

        if (permItem.children) {
          return permItem.children
            .some((child) => myPermission.accountSetting[permItem.value][child.value]);
        }

        return false;
      };

      const hasPermission = checkPermissionValue(item, childItem);

      if (hasPermission) {
        return (
          <Route
            {...rest}
            render={renderLayout}
          />
        );
      }

      showToastError('Bạn không có quyền truy cập');
      return (
        <Redirect
          to={LOCATIONS.LOCATION_LIST}
          from={matchedPath}
        />
      );
    }

    return (
      <Route
        {...rest}
        render={renderLayout}
      />
    );
  };

  if (!accessToken) {
    return (
      <Redirect
        to={LOCATIONS.LOGIN}
        from={path}
      />
    );
  }

  // Kiểm tra quyền truy cập theo loginType
  if (loginTypes && loginTypes.length && !loginTypes.includes(currentLoginType)) {
    return (
      <Redirect
        to={LOCATIONS.DASHBOARD}
        from={path}
      />
    );
  }

  return checkHasPermission();
};

AuthMiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,

  permission: PropTypes.string,
  roles: PropTypes.instanceOf(Object),
  location: PropTypes.instanceOf(Object),
  component: PropTypes.instanceOf(Object),

  layout: PropTypes.instanceOf(Object),
  path: PropTypes.string.isRequired,

  isLoadingGetMyPermission: PropTypes.bool.isRequired,
  myPermission: PropTypes.instanceOf(Object).isRequired,

  loginTypes: PropTypes.arrayOf(PropTypes.string),
};

AuthMiddleware.defaultProps = {
  isAuthProtected: false,

  permission: '',
  roles: {},
  component: {},
  location: {},
  layout: {},
  loginTypes: null,
};

export default AuthMiddleware;
